var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loginContainer"},[_c('dean-header',{attrs:{"logo":_vm.headerLogo,"logo-height":"35"}}),_c('dean-load-overlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }